import React from "react";
import "./Services.css";

import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

import s1sm from "../../assets/images/IMG_4464-sm.jpg";
import s1md from "../../assets/images/IMG_4464-md.jpg";
import s1lg from "../../assets/images/IMG_4464-lg.jpg";

import s2sm from "../../assets/images/IMG_4465-sm.jpg";
import s2md from "../../assets/images/IMG_4465-md.jpg";
import s2lg from "../../assets/images/IMG_4465-lg.jpg";

import s3sm from "../../assets/images/IMG_4467-sm.jpg";
import s3md from "../../assets/images/IMG_4467-md.jpg";
import s3lg from "../../assets/images/IMG_4467-lg.jpg";

import s4sm from "../../assets/images/IMG_4468-sm.jpg";
import s4md from "../../assets/images/IMG_4468-md.jpg";
import s4lg from "../../assets/images/IMG_4468-lg.jpg";

import { useLanguage } from "../../context/LanguageContext";

const Services = () => {
  const { t } = useLanguage();

  return (
    <section className="services-section" id="services">

      {/* HEADING */}
      <div className="services-heading">
        <h2>{t.services.headingTitle}</h2>
        <p>{t.services.headingSubtitle}</p>
      </div>

      {/* SERVICES GRID */}
      <div className="services-grid" data-aos="fade-up">

        <div className="service-card">
          <img
            src={s1sm}
            srcSet={`${s1sm} 600w, ${s1md} 1200w, ${s1lg} 2000w`}
            sizes="(max-width: 900px) 90vw, 25vw"
            alt={t.services.items.facade.alt}
            loading="lazy"
          />
          <h3>{t.services.items.facade.title}</h3>
          <p>{t.services.items.facade.description}</p>
        </div>

        <div className="service-card">
          <img
            src={s2sm}
            srcSet={`${s2sm} 600w, ${s2md} 1200w, ${s2lg} 2000w`}
            sizes="(max-width: 900px) 90vw, 25vw"
            alt={t.services.items.houses.alt}
            loading="lazy"
          />
          <h3>{t.services.items.houses.title}</h3>
          <p>{t.services.items.houses.description}</p>
        </div>

        <div className="service-card">
          <img
            src={s3sm}
            srcSet={`${s3sm} 600w, ${s3md} 1200w, ${s3lg} 2000w`}
            sizes="(max-width: 900px) 90vw, 25vw"
            alt={t.services.items.buildings.alt}
            loading="lazy"
          />
          <h3>{t.services.items.buildings.title}</h3>
          <p>{t.services.items.buildings.description}</p>
        </div>

        <div className="service-card">
          <img
            src={s4sm}
            srcSet={`${s4sm} 600w, ${s4md} 1200w, ${s4lg} 2000w`}
            sizes="(max-width: 900px) 90vw, 25vw"
            alt={t.services.items.roofing.alt}
            loading="lazy"
          />
          <h3>{t.services.items.roofing.title}</h3>
          <p>{t.services.items.roofing.description}</p>
        </div>

      </div>

      {/* CONTACT INFO */}
      <div className="services-info">
        <div className="service-infocol">
          <FaMapMarkerAlt />
          <strong>{t.services.info.addressLabel}</strong>
          <p>{t.services.info.addressValue}</p>
        </div>

        <div className="service-infocol">
          <FaPhoneAlt />
          <strong>{t.services.info.phoneLabel}</strong>
          <p>0658737849</p>
        </div>

        <div className="service-infocol">
          <FaEnvelope />
          <strong>{t.services.info.emailLabel}</strong>
          <p>moniechafaudage@outlook.fr</p>
        </div>
      </div>

    </section>
  );
};

export default Services;
